<div class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto p-2 lg:pl-0">
  <div
    class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">

    <form [formGroup]="invoiceForm" (ngSubmit)="onSave()">
      <h1 class="heading">
        {{ invoiceId ? 'Edit' : 'Add' }}
      </h1>

      <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

      <section class="grid gap-4 sm:grid-cols-2">
        <!-- company -->
        <div class="space-y-1">
          <label class="subheading after:text-red-600 after:content-['*']">Company</label>
          <div>
            <select [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedCompany"
              (ngModelChange)="onCompanyChange()" id="id">
              <option value="" disabled>Select a Company</option>
              <option *ngFor="let company of companies" [value]="company.id">
                {{ company.CompanyName | capitalize }}
              </option>
            </select>
          </div>
          <div *ngIf="submitted && !selectedCompany">
            <p class="pt-1 text-red-600 text-xs">Company is required</p>
          </div>
        </div>

        <!-- customer -->
        <ng-container formGroupName="CustomerRef">
          <div class="space-y-1">
            <label class="subheading after:text-red-600 after:content-['*']">Customer</label>
            <div>
              <select (change)="onCustomerSelect($event)" formControlName="value" id="id">
                <option value="" disabled>Select a customer</option>
                <option *ngFor="let customer of customers" [value]="customer.Id">
                  {{ customer.DisplayName | capitalize }}
                </option>
              </select>
            </div>

            <div *ngIf="submitted && invoiceForm.get('CustomerRef.value')?.errors">
              <p *ngIf="invoiceForm.get('CustomerRef.value')?.errors?.['required']" class="pt-1 text-red-600 text-xs">
                Customer is required
              </p>
            </div>

          </div>
        </ng-container>



        <!-- Due Date -->
        <div class="space-y-1">
          <label class="subheading">
            Due Date
          </label>
          <div class="flex flex-1 gap-2">
            <div class="flex-1">
              <input type="text" name="time" id="time" formControlName="DueDate" [owlDateTime]="DueDate"
                [owlDateTimeTrigger]="DueDate" />
              <owl-date-time [pickerType]="'calendar'" (afterPickerClosed)="onDateChange(invoiceForm.get('DueDate'))"
                #DueDate></owl-date-time>
            </div>
          </div>
          <div *ngIf="submitted && form.DueDate.errors">
            <p *ngIf="form.DueDate.errors.required" class="pt-1 text-red-600 text-xs">
              Due date is required
            </p>
          </div>

        </div>


        <ng-container formGroupName="BillEmail">
          <div class="space-y-1">
            <label class="subheading after:text-red-600 after:content-['*']">
              Email
            </label>
            <div>
              <div>
                <input formControlName="Address" type="text" />
              </div>
              <div *ngIf="submitted && BillEmail.get('Address')?.errors">
                <p *ngIf="BillEmail.get('Address')?.errors?.required" class="pt-1 text-red-600 text-xs">
                  Email is required
                </p>

              </div>
            </div>
          </div>
        </ng-container>


      </section>

      <h1 class="text-[16px] font-semibold mt-4"> Reference </h1>
      <hr class="my-2 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10">
      <section class="grid gap-4 sm:grid-cols-2">

        <div class="">


          <div class="space-y-1">
            <div formGroupName="reference" class="flex gap-2">

              <div class="w-1/2">
                <label class="subheading">
                  Name
                </label>
                <div>
                  <div>
                    <input formControlName="name" name="name" id="name" type="text" />
                  </div>
                </div>
              </div>

              <div class="w-1/2">
                <label class="subheading">
                  ID
                </label>
                <div>
                  <div>
                    <input formControlName="id" name="id" id="id" type="text" />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section class="col-span-full">
        <h3 class="text-lg font-semibold py-4">Line Items</h3>
        <hr class="my-2 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10 mb-4">

        <div *ngIf="lineItems.controls && lineItems.controls.length"
          class="overflow-x-auto border border-zinc-200 dark:border-zinc-700 rounded-lg">
          <table
            class="[&_th]:align-top [&_td]:align-top min-w-full border border-zinc-300 dark:border-zinc-700 border-collapse">
            <thead
              class="bg-zinc-100 dark:bg-zinc-800 text-zinc-700 dark:text-zinc-300 border-b border-zinc-300 dark:border-zinc-700">
              <tr>
                <th
                  class="font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap border border-zinc-300 dark:border-zinc-700 p-2 text-left w-6">
                  #</th>
                <th
                  class="font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap border border-zinc-300 dark:border-zinc-700 p-2 text-left">
                  Detail Type
                </th>

                 <th
                  class="font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap border border-zinc-300 dark:border-zinc-700 p-2 text-left">
                  Service Date
                </th>

                <th
                  class="font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap border border-zinc-300 dark:border-zinc-700 p-2 text-left">
                  Product/Service</th>
                <th
                  class="font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap border border-zinc-300 dark:border-zinc-700 p-2 text-left">
                  Description</th>
                <th
                  class="font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap border border-zinc-300 dark:border-zinc-700 p-2 text-center w-20">
                  Qty</th>
                <th
                  class="font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap border border-zinc-300 dark:border-zinc-700 p-2 text-center w-20">
                  Rate</th>
                <th
                  class="font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap border border-zinc-300 dark:border-zinc-700 p-2 text-center w-20">
                  SKU</th>
                <th
                  class="font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap border border-zinc-300 dark:border-zinc-700 p-2 text-center w-24">
                  Amount</th>
                <th
                  class="font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap border border-zinc-300 dark:border-zinc-700 p-2 text-center w-16">
                  Action</th>
              </tr>
            </thead>

            <tbody formArrayName="Line">
              <tr *ngFor="let item of lineItems.controls; let i = index" [formGroupName]="i"
                class="hover:bg-zinc-50 dark:hover:bg-zinc-900 transition">
                <!-- Index -->
                <td class="border border-zinc-300 dark:border-zinc-700 p-2 text-center">{{ i + 1 }}</td>

                <!-- Detail Type -->
                <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                  <select formControlName="DetailType" class="w-full border rounded-md p-1.5">
                    <option value="">Select Detail Type</option>
                    <option value="SalesItemLineDetail">SalesItemLineDetail</option>
                    <option value="SubTotalLineDetail">SubTotalLineDetail</option>
                    <option value="DiscountLineDetail">DiscountLineDetail</option>
                  </select>

                  <div *ngIf="(submitted || lineItemSubmitted) && item.get('DetailType')?.errors?.['required']">
                    <p class="pt-1 text-red-600 text-xs">Detail type is required</p>
                  </div>
                </td>

                <!-- ServiceDate -->
                <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                  <ng-container formGroupName="SalesItemLineDetail">
                  <div class="space-y-1">
                    <div class="flex flex-1 gap-2">
                      <div class="flex-1">
                        <input type="text" name="time" id="time" formControlName="ServiceDate"
                          [owlDateTime]="ServiceDate" [owlDateTimeTrigger]="ServiceDate" />
                        <owl-date-time [pickerType]="'calendar'"
                          (afterPickerClosed)="onDateChange(lineItems.at(i).get('SalesItemLineDetail.ServiceDate'))" #ServiceDate></owl-date-time>
                      </div>
                    </div>
                  </div>
                  </ng-container>
                </td>

                <!-- Product / Service -->
                <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                  <ng-container formGroupName="SalesItemLineDetail">
                    <ng-container formGroupName="ItemRef">
                      <select (change)="onServiceSelect($event, i)" formControlName="value"
                        class="w-full border rounded-md p-1.5">
                        <option value="">Select Service</option>
                        <option *ngFor="let p of productItems" [value]="p.Id">{{ p.Name }}</option>
                      </select>
                    </ng-container>
                  </ng-container>

                  <div *ngIf="(submitted || lineItemSubmitted) && item.get('SalesItemLineDetail.ItemRef.value')?.errors?.['required']">
                    <p class="pt-1 text-red-600 text-xs">Service is required</p>
                  </div>
                </td>

                <!-- Description -->
                <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                  <input formControlName="Description" type="text" placeholder="Description"
                    class="w-full border rounded-md p-1.5" />
                  <div *ngIf="(submitted || lineItemSubmitted) && item.get('Description')?.errors?.['required']">
                    <p class="pt-1 text-red-600 text-xs">Description is required</p>
                  </div>
                </td>

                <!-- Qty -->
                <td class="border border-zinc-300 dark:border-zinc-700 p-2 text-center">
                  <ng-container formGroupName="SalesItemLineDetail">
                    <input (input)="onQtyChange(i)" formControlName="Qty" type="number" placeholder="0"
                      class="w-16 border rounded-md p-1 text-center" />
                  </ng-container>
                  <div *ngIf="(submitted || lineItemSubmitted) && item.get('SalesItemLineDetail.Qty')?.errors">
                    <p class="pt-1 text-red-600 text-xs">Qty is required</p>
                  </div>
                </td>

                <!-- UnitPrice -->

                <td class="border border-zinc-300 dark:border-zinc-700 p-2 text-center">
                  <ng-container formGroupName="SalesItemLineDetail">
                    <input (input)="onQtyChange(i)" formControlName="UnitPrice" type="number" placeholder="0"
                      class="w-16 border rounded-md p-1 text-center" />
                  </ng-container>
                  <div *ngIf="(submitted || lineItemSubmitted) && item.get('SalesItemLineDetail.UnitPrice')?.errors">
                    <p class="pt-1 text-red-600 text-xs">Rate is required</p>
                  </div>
                </td>

                <!-- Sku -->
                <td class="border border-zinc-300 dark:border-zinc-700 p-2 text-center">
                  <ng-container formGroupName="SalesItemLineDetail">
                    <input formControlName="Sku" [disabled]="true" type="text" placeholder="Sku"
                      class="w-20 border rounded-md p-1 text-center" />
                  </ng-container>
                </td>

                <!-- Amount -->
                <td class="border border-zinc-300 dark:border-zinc-700 p-2 text-center">
                  <input formControlName="Amount" type="text" placeholder="0.00"
                    class="w-24 border rounded-md p-1 text-center" />
                  <div *ngIf="(submitted || lineItemSubmitted) && item.get('Amount')?.errors">
                    <p class="pt-1 text-red-600 text-xs">Amount must be greater than 0</p>
                  </div>
                </td>

                <!-- Remove -->
                <td class="border border-zinc-300 dark:border-zinc-700 p-2 text-center">
                  <div class="flex justify-center items-center">
                    <svg *ngIf="lineItems.length > 1" (click)="removeLineItem(i)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                      stroke-width="1.5" stroke="currentColor" class="text-red-500 hover:text-red-700 h-5 w-5">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                    </svg>
                  </div>

                </td>

              </tr>
            </tbody>
          </table>
        </div>

        <div class="flex justify-end mt-4">
          <button type="button" class="btn btn-secondary" (click)="addLineItem()">+ Add Line Item</button>
        </div>
      </section>



      <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

      <section class="flex justify-end gap-4">
        <button type="submit" class="btn btn-secondary">
          {{ invoiceId ? 'Update' : 'Create' }}
        </button>
      </section>

    </form>
  </div>
</div>